<template>
  <div>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="positionsByLine"
      :items-per-page="100"
      :hide-default-footer="true"
      no-data-text="Currently no transactions to display. . ."
    >
      <template slot="item" slot-scope="item">
        <tr :class="classForRowCategory(item.item.category)">
          <td>{{ displayCategory(item.item.category) }}</td>
          <td v-for="i in Array.from(Array(7).keys())" :key="i">{{ item.item[`date${i}`] }}</td>
          <!-- THAT LAST LINE EXPECTS ITEMS NAMED 'date0', 'date1', etc. -->
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {};
  },
  methods: {
    displayCategory(category) {
      return category
        .split("_")
        .map((word) => {
          return word[0].toUpperCase() + word.slice(1);
        })
        .join(" ");
    },
    classForRowCategory(category) {
      return /_debits|_credits|opening|ending/.test(category.toLowerCase()) ? "header-row" : "";
    },
  },
  computed: {
    headers() {
      let headers = new Set();
      headers.add({ text: "Category", value: "category" });
      let cnt = 0;
      Object.keys(this.dailyPositions).forEach((dateString) => {
        headers.add({ text: dateString, value: `date${cnt}`, sortable: false });
        cnt += 1;
      });

      console.log(headers);
      return Array.from(headers);
    },
    positionsByLine() {
      let lineItems = new Set();
      const dateEntries = Object.keys(this.dailyPositions);

      if (Object.keys(this.dailyPositions).length) {
        const rowHeaders = [];
        for (let [key, value] of this.dailyPositions[
          Object.keys(this.dailyPositions)[0]
        ].entries()) {
          rowHeaders.push(key);
        }
        console.log("ROW HEADERS: ", rowHeaders);

        rowHeaders.forEach((rHeader) => {
          let newObj = {};
          newObj["category"] = rHeader;
          for (let idx in Object.keys(this.dailyPositions)) {
            newObj[`date${idx}`] = this.formatNumberForDisplay(
              this.dailyPositions[dateEntries[idx]].get(rHeader),
              "text"
            );
          }

          lineItems.add(newObj);
        });
      }

      console.log("LINE ITEMS:", lineItems);
      return Array.from(lineItems);
    },
  },
  props: {
    dailyPositions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.header-row {
  font-weight: bolder;
  background: #bbb !important;
  color: white;
}
</style>
